import { useTranslation } from 'react-i18next';

export function DefaultPending() {
  const { t } = useTranslation('common');

  return (
    <div
      data-testid="pending-spinner"
      className="flex flex-col items-center justify-center gap-3 h-screen"
    >
      <div className="w-8 h-8 rounded-full border-[3px] border-border border-t-muted-foreground animate-spin" />
      <span className="text-sm text-muted-foreground">{t('loading')}</span>
    </div>
  );
}
